import { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const ScopedPlmContext = createContext();

function useScopedPlm() {
    return useContext(ScopedPlmContext);
}

export function useScopedPlmId() {
    return useScopedPlm()?.plmId;
}

/**
 * Used to provide a context for links to use when looking for the ID of a PLM
 */
export function ScopedPlmContextProvider(props) {
    const { children, plmId } = props;
    const value = useMemo(() => ({ plmId }), [plmId]);

    return <ScopedPlmContext.Provider value={value}>{children}</ScopedPlmContext.Provider>;
}

export function PlmContextConsumer(props) {
    const { children } = props;
    const { plmId } = useScopedPlm();

    return children(plmId);
}

ScopedPlmContextProvider.propTypes = {
    plmId: PropTypes.string,
};

ScopedPlmContextProvider.defaultProps = {
    plmId: undefined,
};

PlmContextConsumer.propTypes = {
    children: PropTypes.func.isRequired,
};
